export const DEFAULT_CHIRP_TIMEOUT = 5000;